import styled from '@emotion/styled';
import { defaultInput } from './Input';

export const Select = styled.select`
  ${defaultInput}
`;
